import { useEffect, useState } from "react";
import axios from "axios";
import { Database, ShieldCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeader = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("bbc_admin_token")}` } });

export const AdminResearchCard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/admin/research/contributions`, authHeader())
      .then((res) => setStats(res.data))
      .catch(() => setStats(null));
  }, []);

  if (!stats) return null;

  return (
    <div className="bg-slate-900/50 border border-slate-800 p-6" data-testid="admin-research-card">
      <h2 className="font-serif text-xl text-white mb-2 flex items-center gap-2">
        <Database className="w-5 h-5 text-[#D4AF37]" />
        Case base growth
      </h2>
      <p className="text-slate-400 text-sm mb-6 max-w-2xl">
        Every opted-in report, intake form and quiz adds a coded, anonymous case to the matcher — no names, no
        employers, no free text. Clients can withdraw at any time from their dashboard.
      </p>

      <div className="grid sm:grid-cols-4 gap-4 mb-6">
        {[
          { label: "Total cases", value: stats.total_cases, testid: "research-total" },
          { label: "Original dataset", value: stats.seed_cases, testid: "research-seed" },
          { label: "Collected by the clinic", value: stats.contributed_cases, testid: "research-contributed" },
          { label: "Added this week", value: stats.last_7_days, testid: "research-week" },
        ].map((item) => (
          <div key={item.label} className="border border-slate-800 bg-slate-950/60 p-4" data-testid={item.testid}>
            <p className="font-serif text-2xl text-[#D4AF37]">{item.value.toLocaleString()}</p>
            <p className="text-slate-500 text-[10px] uppercase tracking-widest mt-1">{item.label}</p>
          </div>
        ))}
      </div>

      <div className="space-y-2">
        {Object.entries(stats.by_source).map(([source, info]) => (
          <div
            key={source}
            className="flex items-center justify-between border border-slate-800 px-4 py-3"
            data-testid={`research-source-${source}`}
          >
            <span className="text-slate-300 text-sm">{info.label}</span>
            <span className="text-white text-sm">{info.cases.toLocaleString()}</span>
          </div>
        ))}
      </div>

      <p className="text-slate-500 text-xs mt-5 inline-flex items-center gap-2" data-testid="research-optout-count">
        <ShieldCheck size={13} className="text-[#D4AF37]" />
        {stats.opted_out_clients} client{stats.opted_out_clients === 1 ? "" : "s"} opted out of research use
      </p>
    </div>
  );
};
